import { OrganizationType } from "../../enums/common";
import { OrganizationCountry } from "../enums/country";
import { getRegionDisplayName } from "../region/display";
import { resolveRegionCode } from "../region/resolve";
export const isSweepstakesCountry = (country) => country === OrganizationCountry.UnitedStates ||
    country === OrganizationCountry.GreatBritain ||
    country === OrganizationCountry.Canada;
export const shouldShowUsLotteryDisclosures = (country) => country === OrganizationCountry.UnitedStates;
export const getSweepstakesRulesKind = (country) => {
    if (country === OrganizationCountry.GreatBritain) {
        return "ukFreePrizeDraw";
    }
    if (country === OrganizationCountry.Canada) {
        return "canadaContest";
    }
    return "usSweepstakes";
};
export const isSweepstakesBaseEntryRateRequired = (country, organizationType) => country !== OrganizationCountry.UnitedStates || organizationType !== OrganizationType.Charity;
const SWEEPSTAKES_COUNTRY_NAME = {
    [OrganizationCountry.Canada]: "Canada",
    [OrganizationCountry.UnitedStates]: "United States",
    [OrganizationCountry.GreatBritain]: "United Kingdom",
    [OrganizationCountry.Australia]: "Australia",
    [OrganizationCountry.NewZealand]: "New Zealand",
    [OrganizationCountry.Ireland]: "Ireland",
    [OrganizationCountry.Germany]: "Germany",
};
export const getSweepstakesCountryName = (country) => country ? SWEEPSTAKES_COUNTRY_NAME[country] : null;
export const getSweepstakesEligibleTerritory = (country) => {
    if (country === OrganizationCountry.UnitedStates) {
        return "the fifty (50) United States and the District of Columbia";
    }
    const countryName = getSweepstakesCountryName(country);
    return countryName && country === OrganizationCountry.GreatBritain ? `the ${countryName}` : countryName;
};
export const getSweepstakesSponsorTaxIdLabel = (country, type) => {
    if (country === OrganizationCountry.UnitedStates) {
        return "EIN";
    }
    return type === OrganizationType.Charity ? "registered charity number" : "registration number";
};
export const getSweepstakesSponsorEntityType = (country, type) => {
    switch (type) {
        case OrganizationType.Charity:
            return country === OrganizationCountry.UnitedStates
                ? "a 501(c)(3) nonprofit organization"
                : "a registered charity";
        case OrganizationType.Other501C:
            return "a 501(c) tax-exempt organization";
        case OrganizationType.Social:
            return "a nonprofit social enterprise";
        case OrganizationType.Private:
            return "a private business";
        default:
            return null;
    }
};
export const formatSweepstakesEntryLevels = (levels) => levels
    .map(({ title, entryCount, formattedAmount }) => {
    const count = entryCount && entryCount > 0 ? entryCount : 1;
    const level = `${count} ${count === 1 ? "entry" : "entries"} for ${formattedAmount}`;
    return title ? `${title}: ${level}` : level;
})
    .join("\n") || null;
export const getSweepstakesFreeEntryCount = (rates) => {
    const bundleEntryCounts = rates
        .map(({ attendeesByTicket }) => attendeesByTicket ?? 1)
        .filter((entryCount) => entryCount > 1);
    return bundleEntryCounts.length > 0 ? Math.min(...bundleEntryCounts) : 1;
};
export const hasForbiddenSweepstakesWording = (text) => /\braffles?\b/i.test(text ?? "");
export const SWEEPSTAKES_PRIZE_VALUE_LIMIT = 500_000;
const SWEEPSTAKES_PRIZE_LIMIT_EXEMPT_TYPES_BY_REGION = {
    NY: [OrganizationType.Charity],
    FL: [OrganizationType.Charity, OrganizationType.Other501C],
};
export const getSweepstakesPrizeValueRestriction = ({ country, region, organizationType, totalPrizeValue, }) => {
    if (country !== OrganizationCountry.UnitedStates || totalPrizeValue <= SWEEPSTAKES_PRIZE_VALUE_LIMIT) {
        return { isRestricted: false, regionName: null };
    }
    const regionCode = resolveRegionCode(country, region);
    const exemptTypes = regionCode ? SWEEPSTAKES_PRIZE_LIMIT_EXEMPT_TYPES_BY_REGION[regionCode] : undefined;
    if (!regionCode || !exemptTypes || (organizationType && exemptTypes.includes(organizationType))) {
        return { isRestricted: false, regionName: null };
    }
    return { isRestricted: true, regionName: getRegionDisplayName(country, regionCode) };
};
export const sumSweepstakesPrizeValues = (prizes) => prizes.reduce((total, prize) => total + (prize.value ?? 0), 0);
